import { useRef, useEffect } from 'react';
/** 交互组件 */
import {
    /** XFlow核心组件 */
    XFlow,
    /** 流程图画布组件 */
    FlowchartCanvas,
    /** 流程图配置扩展 */
    FlowchartExtension,
    /** 流程图节点组件 */
    FlowchartNodePanel,
    /** 流程图表单组件 */
    FlowchartFormPanel,
    /** 通用组件：快捷键 */
    KeyBindings,
    /** 通用组件：画布缩放 */

    /** 通用组件：右键菜单 */
    CanvasContextMenu,
    /** 通用组件：工具栏 */
    CanvasToolbar,
    /** 通用组件：对齐线 */
    CanvasSnapline,
    /** 通用组件：节点连接桩 */
    CanvasNodePortTooltip,
    XFlowGraphCommands,
    createGraphConfig,
} from '@antv/xflow';
/** 配置Command*/
import { useCmdConfig } from './config/config-cmd';
/** 配置Menu */
import { useMenuConfig } from './config/config-menu';
/** 配置Toolbar */
import { useToolbarConfig } from './config/config-toolbar';
/** 配置快捷键 */
import { useKeybindingConfig } from './config/config-keybinding';
/** 配置Dnd组件面板 */

import './xflow.css';
import { useState } from 'react';
import { useScaleConfig } from './config/config-scale';

let appRef = undefined;

/**  graphConfig：配置Graph  */
export const useGraphConfig = createGraphConfig((graphConfig) => {
    graphConfig.setDefaultNodeRender((props) => {
        return <div className="react-node"> {props.data.label} </div>;
    });
});
const XflowComponent = ({
    meta,
    btnRef,
    setValueSave,
    graphData,
    viewMode,
}) => {
    const [loading_, setLoading_] = useState(false);
    const toolbarConfig = useToolbarConfig(btnRef, setValueSave)();
    const menuConfig = useMenuConfig();
    const scaleConfig = useScaleConfig(loading_, setLoading_)();
    const keybindingConfig = useKeybindingConfig();
    const graphRef = useRef();
    const commandConfig = useCmdConfig();
    /**
     * @param app 当前XFlow工作空间
     * @param extensionRegistry 当前XFlow配置项
     */
    const onLoad = async (app) => {
        appRef = app;
        graphRef.current = await app.getGraphInstance();
    };
    useEffect(() => {
        if (graphRef.current) {
            graphRef.current.on('node:click', (...arg) => {
                console.log(arg);
            });
        }
    }, [graphRef]);

    useEffect(() => {
        const load = async () => {
            await appRef?.executeCommand(XFlowGraphCommands.GRAPH_RENDER.id, {
                graphData,
            });
        };
        load();
    }, [graphData]);

    useEffect(() => {
        setTimeout(
            () =>
                appRef.executeCommand(XFlowGraphCommands.GRAPH_ZOOM.id, {
                    factor: 'fit',
                }),
            500
        );
    }, []);

    if (viewMode) {
        return (
            <XFlow
                graphData={graphData}
                className="xflow-graph-zoom"
                commandConfig={commandConfig}
                onLoad={onLoad}
                meta={meta}
            >
                <FlowchartExtension />
                <CanvasToolbar
                    layout="vertical"
                    config={scaleConfig}
                    position={{ top: 12, left: 12 }}
                />
                <FlowchartCanvas
                    mode="scan"
                    position={{ top: 40, left: 0, right: 0, bottom: 0 }}
                >
                    <CanvasSnapline color="#faad14" />
                    <CanvasNodePortTooltip />
                </FlowchartCanvas>

                <KeyBindings config={keybindingConfig} />
            </XFlow>
        );
    } else
        return (
            <XFlow
                className="xflow-graph-zoom"
                commandConfig={commandConfig}
                onLoad={onLoad}
                meta={meta}
            >
                <FlowchartExtension />

                <FlowchartNodePanel
                    showHeader={false}
                    position={{ width: 162, top: 40, bottom: 0, left: 0 }}
                />

                <CanvasToolbar
                    className="xflow-workspace-toolbar-top"
                    layout="horizontal"
                    config={toolbarConfig}
                    position={{ top: 0, left: 0, right: 0, bottom: 0 }}
                />

                <CanvasToolbar
                    className="xflow-workspace-toolbar-top"
                    layout="horizontal-center"
                    config={scaleConfig}
                    position={{ top: 0, right: 0, bottom: 0 }}
                />

                <FlowchartCanvas position={{ top: 40, right: 0, bottom: 0 }}>
                    <CanvasContextMenu config={menuConfig} />
                    <CanvasSnapline color="#faad14" />
                    <CanvasNodePortTooltip />
                </FlowchartCanvas>

                <FlowchartFormPanel
                    show={true}
                    position={{ width: 200, top: 40, bottom: 0, right: 0 }}
                    // controlMapService={controlMapService}
                    // formSchemaService={formSchemaService}
                />

                <KeyBindings config={keybindingConfig} />
            </XFlow>
        );
};
export default XflowComponent;
